//import external from "../externalModules.js";
//import { getToolState } from "../stateManagement/toolState.js";
import Cache from "core/cache/index";
import makeKey from "core/cache/KeyGen.js";
import { getEnabledElement } from "component/toolManager/enabledElements.js";
import triggerEvent from "core/customEvent/triggerEvent.js";
//import loadHandlerManager from "../stateManagement/loadHandlerManager.js";
import math from "core/math";
import Helper from "helper";
//import convertToVector3 from "../util/convertToVector3.js";

// In the future we will want to have a way to manually register links sets of the same orientation (e.g. an axial link set from a prior with an axial link set of a current).  The user could do this by scrolling the two stacks to a similar location and then doing a user action (e.g. right click link) at which point the system will capture the delta between the image position (patient) of both stacks and use that to sync them.  This offset will need to be adjustable.

/**
 * Manual 프레임 일치
 * Calculate a position in space that is offset from the source image's position,
 * and synchronize the target stack to the image that is closest to that position.
 * @export
 * @public
 * @method
 * @name stackImagePositionOffsetSynchronizer
 *
 * @param {Object} synchronizer - The Synchronizer instance that attaches this
 * handler to an event
 * @param {HTMLElement} sourceElement - The source element
 * @param {HTMLElement} targetElement - The target element
 * @param {Object} eventData - The data object from the triggering event
 * @param {Object} positionDifference - An object with { x, y, z } values that will be
 * added to the source image's coordinates
 * @returns {void}
 */
export default function (
  synchronizer,
  sourceElement,
  targetElement,
  eventData,
  positionDifference
) {
  // Ignore the case where the source and target are the same enabled element
  if (targetElement === sourceElement) {
    return;
  }

  let metadataCache = new Cache.Metadata();
  const sourceElementStub = getEnabledElement(sourceElement);

  const sourceImageId = sourceElementStub.image.sopInstanceUID;
  const sourceSeriesKey = makeKey(
    sourceElementStub.image.seriesInstanceUID,
    sourceElementStub.image.modality
  );

  let sourceImagePlane = metadataCache.getImagePlaneModule(sourceSeriesKey);
  sourceImagePlane.imagePositionPatient = sourceElementStub.image.imagePosition;
  sourceImagePlane.frameOfReferenceUID =
    sourceElementStub.image.frameOfReferenceUID;

  if (
    Helper.Validator.isDefined(sourceImagePlane.imagePositionPatient) === false
    // sourceImagePlane === undefined ||
    // sourceImagePlane.imagePositionPatient === undefined
  ) {
    return;
  }

  const sourceImagePosition = math.vector.convertToVector3(
    sourceImagePlane.imagePositionPatient
  );

  const targetElementStub = getEnabledElement(targetElement);

  const targetSeriesKey = makeKey(
    targetElementStub.image.seriesInstanceUID,
    targetElementStub.image.modality
  );

  let minDistance = Number.MAX_VALUE;
  let newImageIdIndex = -1;

  if (!positionDifference) {
    return;
  }

  const finalPosition = sourceImagePosition.clone().add(positionDifference);

  const stackData = metadataCache.get(targetSeriesKey).stack[0].frame;
  let nearImagePosition = null;
  stackData.forEach(function (frame, index) {
    if (frame.imagePosition === undefined) {
      return;
    }

    const imagePosition = math.vector.convertToVector3(frame.imagePosition);
    const distance = finalPosition.distanceToSquared(imagePosition);

    if (distance < minDistance) {
      minDistance = distance;
      newImageIdIndex = index;
      nearImagePosition = imagePosition;
    }
  });

  if (
    newImageIdIndex === stackData.currentImageIdIndex ||
    newImageIdIndex === -1
  ) {
    return;
  }
  // console.log("finalPosition : " + finalPosition.toString());
  // console.log(finalPosition);
  // console.log("imagePosition : ");
  // console.log(nearImagePosition);
  // console.log("minDistance : ");
  // console.log(minDistance);

  const data = {
    newImageIndex: newImageIdIndex + 1,
  };
  // console.log("sync. targetElement : " + targetElement.id);
  // console.log(newImageIdIndex + 1);
  triggerEvent(targetElement, "onChangeScrollbar", data);
}
